import classNames from "classnames";
import { CommonComponentProps } from "../../config";
import styles from "./profileCard.module.scss";

export const ProfileCard = (props: ProfileCardProps) => {
  const {
    image,
    name,
    title,
    options: { sizeDesktop, sizeMobile, sizeTablet },
  } = props;

  return (
    <div
      className={classNames(
        styles.container,
        styles[`${sizeMobile}Mobile`],
        styles[`${sizeTablet}Tablet`],
        styles[`${sizeDesktop}Desktop`],
      )}
    >
      {image && (
        <div className={styles.imageContainer}>
          <img src={image} alt={name} className={styles.image} loading="lazy" />
        </div>
      )}
      {name && <div className={styles.name}>{name}</div>}
      {title && <div className={styles.title}>{title}</div>}
    </div>
  );
};

export interface ProfileCardProps extends CommonComponentProps {
  image: string;
  name: string;
  title: string;
}
